import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { agreeWriteOffActItemAccountantAPI } from '../../../../../api/writeOff/writeOffActItemAPI'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../form/fields/DisagreeTextMain'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'

const AgreeAccountantForm = ({ writeOffActItemBd, setOpen }) => {

	const dispatch = useDispatch()

    const [data, setData] = useState(writeOffActItemBd ? {
        isAgreeAccountant: writeOffActItemBd.isAgreeAccountant,
        disagreeAccountantText: writeOffActItemBd.disagreeAccountantText
    } : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeWriteOffActItemAccountantAPI({
            id: writeOffActItemBd.id,
            isAgreeAccountant: data.isAgreeAccountant,
            disagreeAccountantText: data.disagreeAccountantText
        }).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
                // dispatch(editSupplyBillsItemsAllItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження позиції в акті бухгалтером
            </p>
        </div>
        {
			formDataProductIsField('agree', 'writeOffActItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'writeOffActItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeAccountant', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeAccountant', e)}
					forciblyValue={
                        data && data.isAgreeAccountant === true ? true :
                        data && data.isAgreeAccountant === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'writeOffActItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeAccountant === false || data.isAgreeAccountant === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'writeOffActItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeAccountantText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeAccountantText', e)}
					forciblyValue={data ? data.disagreeAccountantText : ''}
                    className={data && (data.isAgreeAccountant === false || data.isAgreeAccountant === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeAccountantForm